import {AppRoutes} from "./routes/Routes";

export const App = () => {
    return<AppRoutes />
}
